module.exports = __webpack_public_path__ + "img/rainbow-pink-yellow-red.13b27183.svg";